import { useState } from 'react'

import {
  getFilesGalleryActiveEntry,
  getFilesGallerySettledEntry,
  isSameFilesGalleryEntry,
} from './useFilesGallery.utils'

export function useFilesGallery({ files }) {
  const [active, setActive] = useState(() =>
    getFilesGalleryActiveEntry(files, 0)
  )

  const settled = getFilesGallerySettledEntry(files, active)

  // Committed during render so the next `files` change starts from the visible file
  if (!isSameFilesGalleryEntry(settled, active)) {
    setActive(settled)
  }

  function handleSelectListItemFile(id) {
    setActive(
      getFilesGalleryActiveEntry(
        files,
        files.findIndex(file => file.id === id)
      )
    )
  }

  function handleClickNext() {
    setActive(getFilesGalleryActiveEntry(files, settled.index + 1))
  }

  function handleClickPrev() {
    setActive(getFilesGalleryActiveEntry(files, settled.index - 1))
  }

  const activeFileListIndex = settled.index

  return {
    activeFile: files[activeFileListIndex],
    activeFileListIndex,
    showNext: files.length > 1 && activeFileListIndex < files.length - 1,
    showPrev: activeFileListIndex > 0,
    onClickNext: handleClickNext,
    onClickPrev: handleClickPrev,
    onSelectFileListItem: handleSelectListItemFile,
  }
}
